import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '@shadcn/ui/accordion';
import React from 'react';

import { Header, HeaderLevels } from '../../atoms/header/header';
import { Text, TextSize } from '../../atoms/text/text';

interface AccordianProps {
  readonly headerLevel?: HeaderLevels;
  readonly textSize?: TextSize;
  readonly items: { title: string; content: string | React.ReactNode }[];
}

export function Accordian({ headerLevel = 'h4', items, textSize }: AccordianProps) {
  return (
    <Accordion collapsible type="single">
      {items.map((item) => {
        return (
          <AccordionItem key={item.title} value={item.title}>
            <AccordionTrigger className="flex-row-reverse justify-end gap-2">
              <Header level={headerLevel}>{item.title}</Header>
            </AccordionTrigger>
            <AccordionContent>
              <Text size={textSize}>{item.content}</Text>
            </AccordionContent>
          </AccordionItem>
        );
      })}
    </Accordion>
  );
}

export type { AccordianProps };
